import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { newFetch, GET } from '../../../helpers/fetch'
import _ from 'lodash'

const InstructionsList = ({ history }) => {
  const [instructions, setInstructions] = useState([])

  const fetchInstructions = async () => {
    let api_path = `/communication/mycommunications`
    let response = await newFetch(GET, api_path)

    response.success && setInstructions(response.data)
  }

  useEffect(() => {
    fetchInstructions()
  }, [])

  return (
    <>
      {instructions.length > 0 &&
        instructions.map((instruction) => (
          <div key={instruction.id} className="border-bottom">
            <div className="container row w-100 ml-0 p-2 d-flex align-items-center justify-items-center bg-white">
              <div className="col-2">
                {!instruction.is_read ? (
                  <i
                    className="fas fa-circle text-danger"
                    style={{ fontSize: '0.5rem' }}
                  />
                ) : (
                  <i className="far fa-circle" style={{ fontSize: '0.5rem' }} />
                )}
              </div>
              <div
                className="col-10"
                onClick={() =>
                  history.push(
                    `/communications/instructions/${instruction.communication_id}`
                  )
                }
              >
                <strong
                  style={{ wordBreak: 'break-all' }}
                  className={
                    instruction.is_read ? 'text-muted' : 'font-weight-bold'
                  }
                >
                  {instruction.communication.title}
                </strong>
                <div style={{ wordBreak: 'break-all' }}>
                  {_.truncate(instruction.communication.description, {
                    length: 50,
                  })}
                </div>
                <div className="pt-2">
                  {/* <small>{moment(notification.createdAt).format('LT')}</small> */}
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  )
}

export default withRouter(InstructionsList)
